export const WEBSOCKET_AUTH_PROTOCOL = 'shuttle.auth.v1';
export const WEBSOCKET_JWT_PROTOCOL_PREFIX = 'jwt.';

export const buildWebSocketAuthProtocols = (token) => [
  WEBSOCKET_AUTH_PROTOCOL,
  `${WEBSOCKET_JWT_PROTOCOL_PREFIX}${token}`
];

export const createAuthenticatedWebSocket = (url, token) => (
  new WebSocket(url, buildWebSocketAuthProtocols(token))
);
